/**
 * Returns whether the given field, of the given module type, with the given configuration, triggers
 * the module's fields repopulation.
 * @param {string} moduleType
 * @param {{}}     moduleFieldsConfig
 * @param {string} field
 * @return {boolean}
 */
export function moduleFieldTriggersPopulation(moduleType, moduleFieldsConfig, field) {
  return Array.isArray(moduleFieldsConfig)
    && moduleFieldsConfig.length > 0
    && (moduleFieldsConfig.find(fieldConfig => fieldConfig.field === field) || {}).triggerPopulation === true;
}


/**
 * List of fields that modifies the module fields config, grouped by module type.
 * @type {{string: string[]}}
 */
export const fieldsThatAltersModuleFieldsConfig = {
  'modules.content': ['template'],
};

/**
 * List of module types that may have their fields config altered.
 * @type {string[]}
 */
export const moduleTypesThatAltersFieldsConfig = Object.keys(fieldsThatAltersModuleFieldsConfig);

/**
 * Returns whether the given field of the given module type triggers the modification of the
 * module's fields configuration.
 * @param {string} moduleType
 * @param {string} field
 * @return {boolean}
 */
export function moduleFieldTriggersFieldsConfigAlteration(moduleType, field) {
  return moduleTypesThatAltersFieldsConfig.includes(moduleType)
    && fieldsThatAltersModuleFieldsConfig[moduleType].includes(field);
}

export const DISPLAY_DESKTOP = 1;
export const DISPLAY_TABLET = 2;
export const DISPLAY_MOBILE = 3;

// Portadas
const boardDisplayModes = {
  [DISPLAY_MOBILE]: {
    modeId: DISPLAY_MOBILE,
    width: '375px',
    icon: 'phone_iphone',
  },
  [DISPLAY_TABLET]: {
    modeId: DISPLAY_TABLET,
    width: '1024px',
    icon: 'tablet_mac',
  },
  [DISPLAY_DESKTOP]: {
    modeId: DISPLAY_DESKTOP,
    width: '100%',
    icon: 'desktop_mac',
  },
};

// portadas
export const displayModesCompositionEditor = {
  defaultDisplayMode: DISPLAY_DESKTOP,
  displayModes: boardDisplayModes,
  /**
   * @type {{component: Vue, name: string, active: boolean, icon: string }[]}
   */
  additionalModes: [],
};

// Contenidos
const contentDisplayModes = {
  [DISPLAY_MOBILE]: {
    modeId: DISPLAY_MOBILE,
    width: '375px',
    icon: 'phone_iphone',
  },
  [DISPLAY_TABLET]: {
    modeId: DISPLAY_TABLET,
    width: '1024px',
    icon: 'tablet_mac',
  },
  [DISPLAY_DESKTOP]: {
    modeId: DISPLAY_DESKTOP,
    width: '100%',
    icon: 'desktop_mac',
  },
};

// contenidos
export const displayModesContentEditor = {
  defaultDisplayMode: DISPLAY_MOBILE,
  displayModes: contentDisplayModes,
  /**
   * @type {{component: Vue, name: string, active: boolean, icon: string }[]}
   */
  additionalModes: [],
};

export default {
  fieldsThatAltersModuleFieldsConfig,
  moduleTypesThatAltersFieldsConfig,
  moduleFieldTriggersPopulation,
  moduleFieldTriggersFieldsConfigAlteration,
};
